import { FormErrorType } from '../types/form-error.type';

export const defaultFormErros: FormErrorType = {
  REQUIRED: 'Este campo é obrigatório',
  INVALID_CPF: 'O CPF é inválido',
  INVALID_CNPJ: 'O CNPJ é inválido',
  INVALID_EMAIL: 'O e-mail informado não é válido',
  INVALID_ZIPCODE: 'O CEP é inválido'
};
